import "./styles.scss";

import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";

import { decryptIfEncrypted } from "../../../utils/fieldDecryptor";

const ModalDetailReportCSCM = ({ showModal, setShowModal, data }) => {
  const { t } = useTranslation();

  const handleClose = () => setShowModal(false);

  const statusFormatted = {
    pendent: "FILL",
    done: "EVALUATED",
    "done-delayed": "ASSESSED_LATE",
    "pendent-delayed": "RATING_PENDING",
  };

  const nameStudent = (item) => {
    const studentName = decryptIfEncrypted(item.student) ?? "--";
    const [firstName = "", secondName = ""] = studentName.split(" ");
    return `${firstName} ${secondName}`.trim();
  };

  const CardList = (item) => {
    return (
      <div key={item?.id} className="cardList">
        <p className="cardListTime">{item?.timetotal?.teacher_timetotal}</p>
        <p className="cardListName">{nameStudent(item)}</p>
        <p className={`${item?.status?.toLowerCase()}`}>{t(statusFormatted[item?.status])}</p>
      </div>
    );
  };

  return (
    data && (
      <Dialog
        open={showModal}
        onClose={handleClose}
        className="modalPrivilege"
        classes={"modalDetailReportCSCM"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="containerDetailReportCSCM">
          <h1 className="title">{t("FORM_DETAIL")}</h1>

          <div className="content">{data.map((item) => CardList(item))}</div>

          <div className="footer">
            <button type="button" onClick={handleClose} className="buttonModalBack">
              {t("BACK")}
            </button>
          </div>
        </div>
      </Dialog>
    )
  );
};

export default ModalDetailReportCSCM;
